import { render, staticRenderFns } from "./FoMain.vue?vue&type=template&id=3445403b&"
import script from "./FoMain.vue?vue&type=script&lang=js&"
export * from "./FoMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports